<template>
  <ul class="list-group" :class="{ 'has-top-border': hasTopBorder }">
    <TaskListItem
      v-for="(item, index) in tasks"
      :key="`task${item.type_id}_${index}`"
      :stepId="stepId"
      :taskId="item.task_id"
      :taskStatusId="item.task_status_id"
      :taskTypeId="item.type_id"
      :name="item.task_name"
      :url="item.link_url"
      :isComplete="item.complete"
      :isUnavailable="item.unavailable"
      :isLocked="item.lock_flag"
      :isMenuOpen="openMenuIndex === index"
      :revision="item.revision"
      :bulkFlag="bulkFlag"
      :linkType="item.link_type"
      @toggleMenu="isOpen => toggleMenu(index, isOpen)"
      @complete="onComplete"
      @delete="onDelete"
      @revert="onRevert"
      @check="onChecks"
    />
  </ul>
</template>

<script>
import TaskListItem from '@/components/TaskListItem.vue'

export default {
  components: {
    TaskListItem
  },

  props: {
    stepId: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    deletedTask: {
      type: Boolean,
      default: false,
      required: false
    },
    hasTopBorder: {
      type: Boolean,
      default: false,
      required: false
    },
    bulkFlag: {
      type: Boolean,
      default: false,
      required: false
    },
  },

  data() {
    return {
      openMenuIndex: null,
      checks: [],
      check: [],
    }
  },

  computed: {
    tasks() {
      const unavailableOnly = item => item.unavailable
      const availableOnly = item => !item.unavailable
      const filterFunc = this.deletedTask ? unavailableOnly : availableOnly
      return this.items.filter(filterFunc)
    }
  },

  methods: {
    onComplete(...args) {
      this.$emit('complete', ...args)
    },
    onRevert(...args) {
      this.$emit('revert', ...args)
    },
    onDelete(...args) {
      this.$emit('delete', ...args)
    },
    onChecks(check) {
      if (this.checks.includes(check)) {
        this.checks.splice(this.checks.indexOf(check), 1)
      } else {
        this.checks.push(check)
      }
      this.$emit('checks', this.checks)
    },

    toggleMenu(index, isOpen) {
      this.resetMenu()

      if (isOpen) {
        this.openMenuIndex = index
      }
    },
    resetMenu() {
      this.openMenuIndex = null
    }
  },

  watch: {
    $route: {
      handler: 'resetMenu',
      immediate: true
    }
  },

  mounted() {
    document.body.addEventListener('click', this.resetMenu)
  },

  destroyed() {
    document.body.removeEventListener('click', this.resetMenu)
  }
}
</script>
